import Bloc from './Bloc.js';
import Types from './Types.js';

export default class CountEnemies extends Bloc {

	constructor (src, ctx) {

		super("countenemies", src, ctx);
		this.f = (src, ins) => {
			const filter = ins[0] || (() => true);
			const excluded = ins[1];
			const enemies = src.master.liveEnemies
				.filter(enemy => enemy !== excluded)
				.filter(enemy => filter(enemy));
			return [enemies.length];
		}
		this.types = [Types.entityfilter, Types.entity];
	}
}
